import { xenvActionFactory } from '../xenv';
import { alimpLocate, alipayLocate, 
// bdmpLocate,
cowxmpLocate, driverLocate, drwxmpLocate, gjwxmpLocate, h5Locate, kfalimpLocate, kfdriverLocate, kfdwxmpLocate, kfpassengerLocate, kfwxmpLocate, mqqLocate, passengerLocate, qjwxmpLocate, 
// qqmpLocate,
thwxmpLocate, weixinLocate, wxmpLocate, dympLocate, yxwxmpLocate, gaswxmpLocate, esappLocate, hitchappLocate, sfcwxmpLocate, sfcalimpLocate, hywxmpLocate, hyalimpLocate, hydriverLocate, cralimpLocate, eshwxmpLocate, hwfastappLocate, hypassengerLocate } from '../platform/xenv';
import { storage } from '../storage';
import { utils } from '../utils';
import { hashQuery, query } from '../query';
const xenvLocateConfig = {
    'alimp': alimpLocate,
    'alipay': alipayLocate,
    // 'bdmp': bdmpLocate,
    'cowxmp': cowxmpLocate,
    'sfcwxmp': sfcwxmpLocate,
    'sfcalimp': sfcalimpLocate,
    'driver': driverLocate,
    'drwxmp': drwxmpLocate,
    'gjwxmp': gjwxmpLocate,
    'h5': h5Locate,
    'kfalimp': kfalimpLocate,
    'kfdriver': kfdriverLocate,
    'kfdwxmp': kfdwxmpLocate,
    'kfpassenger': kfpassengerLocate,
    'kfwxmp': kfwxmpLocate,
    'mqq': mqqLocate,
    'passenger': passengerLocate,
    'esapp': esappLocate,
    'qjwxmp': qjwxmpLocate,
    // 'qqmp': qqmpLocate,
    'thwxmp': thwxmpLocate,
    'weixin': weixinLocate,
    'wxmp': wxmpLocate,
    'dymp': dympLocate,
    'yxwxmp': yxwxmpLocate,
    'gaswxmp': gaswxmpLocate,
    'hitchapp': hitchappLocate,
    'hywxmp': hywxmpLocate,
    'hyalimp': hyalimpLocate,
    'hydriver': hydriverLocate,
    'cralimp': cralimpLocate,
    'eshwxmp': eshwxmpLocate,
    'hwfastapp': hwfastappLocate,
    'hypassenger': hypassengerLocate
};
export const locate = (option) => {
    const fn = xenvActionFactory('locate', xenvLocateConfig);
    try {
        window.PerfTrack.PrivateMethods.LocateStart();
        // eslint-disable-next-line no-empty
    }
    catch (_) { }
    if (option?.useQuickOption && option?.useQuickOption !== 'none') {
        const queryLocateInfo = easyLocate(option);
        if (Object.keys(queryLocateInfo).length) {
            /* 链接中获取定位信息成功 存入缓存 */
            storage.locationInfo = {
                lat: Number(queryLocateInfo.lat) || undefined,
                lng: Number(queryLocateInfo.lng) || undefined,
                cityId: Number(queryLocateInfo.cityId) || undefined
            };
            let newRiskParams = Object.assign({}, storage.riskParams, { latitude: queryLocateInfo.lat, longitude: queryLocateInfo.lng });
            utils.cleanEmptyKey(newRiskParams);
            storage.riskParams = newRiskParams;
            /* 增加埋点 */
            try {
                window.PerfTrack.customTrack('$_use_quick_locate');
                window.PerfTrack.PrivateMethods.LocateEnd();
                // eslint-disable-next-line no-empty
            }
            catch (_) { }
            return Promise.resolve({
                lat: Number(queryLocateInfo.lat) || undefined,
                lng: Number(queryLocateInfo.lng) || undefined,
                cityId: Number(queryLocateInfo.cityId) || undefined
            });
        }
    }
    return fn(option)
        .then(res => {
        try {
            window.PerfTrack.PrivateMethods.LocateEnd();
            // eslint-disable-next-line no-empty
        }
        catch (_) { }
        return res;
    })
        .catch(error => {
        try {
            window.PerfTrack.PrivateMethods.LocateEnd();
            // eslint-disable-next-line no-empty
        }
        catch (_) { }
        return Promise.reject(error);
    });
};
/**
 * @name: 根据入参取链接上定位信息
 * @param {object} option
 * @return {*}
 */
function easyLocate(option) {
    const { useQuickOption } = option || {};
    const queryParams = Object.assign({}, query(), hashQuery());
    const cityId = Number(queryParams.cityId || queryParams.cityid || queryParams.city_id || 0);
    const lat = Number(queryParams.latitude || queryParams.lat || 0);
    const lng = Number(queryParams.longitude || queryParams.lng || 0);
    let result = {};
    switch (useQuickOption) {
        case 'city':
            if (cityId)
                result = utils.cloneDeep({ cityId, lat, lng });
            break;
        case 'lat_lng':
            if (lat && lng)
                result = utils.cloneDeep({ lat, lng, cityId });
            break;
        case 'all':
            if (cityId && lat && lng)
                result = utils.cloneDeep({ cityId, lat, lng });
            break;
        case 'any':
            if (cityId || (lat && lng))
                result = utils.cloneDeep({ cityId, lat, lng });
            break;
        default:
            break;
    }
    return result;
}
export { easyLocate };
